export default "__VITE_ASSET__DrTsFoST__"